export function initAnchors(languageCode) {
    const gridContainer = document.querySelector('.grid-container');

    gridContainer.className = `grid-container lang-${languageCode}`;
}
